import Vue from 'vue'
import { ThemeBackgroundHover } from 'javascript/Directives'

export default () => {
  Vue.directive('theme', function (el, { value = true }) {
    el.style.backgroundColor = value ? 'var(--tripla-theme-color)' : ''
    el.style.color = value ? 'var(--tripla-text-color)' : ''
  })

  Vue.directive('theme-font', function (el, { value = true }) {
    el.style.color = value ? 'var(--tripla-theme-color)' : ''
  })

  Vue.directive('theme-fill', function (el, { value = true }) {
    el.style.fill = value ? 'var(--tripla-theme-color)' : ''
  })

  Vue.directive('theme-outline', function (el) {
    el.style.color = 'var(--tripla-theme-color)'
    el.style.border = `1px solid ${'var(--tripla-theme-color)'}`
    el.addEventListener('mouseover', () => {
      el.style.background = 'var(--tripla-theme-color)'
      el.style.color = 'var(--tripla-text-color)'
    })
    el.addEventListener('mouseout', () => {
      el.style.background = 'none'
      el.style.color = 'var(--tripla-theme-color)'
    })
  })

  Vue.directive('theme-light', function (el, { value = true }) {
    el.style.backgroundColor = value ? 'var(--tripla-theme-color)' : '' // vue switch the color code to rgb automatically #000 => rgb(0, 0, 0)
    el.style.backgroundColor = value
      ? el.style.backgroundColor.replace('rgb', 'rgba').replace(')', ', 0.4)')
      : ''
  })

  Vue.directive('theme-bg-hover', ThemeBackgroundHover)
}
